import { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api, ApiError, type Me } from './lib/api';

/** The signed-in member (null when not signed in). */
export function useMe() {
  return useQuery<Me | null>({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await api<Me>('/auth/me');
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 5 * 60_000,
  });
}

export type ToastFn = (msg: string, undo?: () => void) => void;
export const ToastCtx = createContext<ToastFn>(() => {});
export const useToast = () => useContext(ToastCtx);
